import { Box, Dialog } from "@mui/material";
import { contactPersonData } from "data/supplierPageData";
import { useState } from "react";
import ContactPersonDetails from "../ContactPersonDetails/ContactPersonDetails";
import {
	SupplierModalActions,
	SupplierModalHeader,
	modalContentSx,
	supplierModalPaperProps,
} from "../../../shared/supplierUi";

const EditContactPersons = ({ modalOpen, setModalOpen, selected, setSelected, submitFunction }) => {
	const [updatedDetails, setUpdatedDetails] = useState(selected ? selected : contactPersonData);

	const handleCloseModal = () => {
		setUpdatedDetails(contactPersonData);
		setModalOpen(false);
		setSelected();
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();
		if (typeof submitFunction === "function") {
			let result = await submitFunction(updatedDetails);
			if (result) {
				setSelected();
				setModalOpen(false);
			}
		}
	};
	return (
		<Dialog
			fullWidth
			maxWidth="md"
			open={modalOpen}
			onClose={handleCloseModal}
			component="form"
			onSubmit={handleFormSubmit}
			PaperProps={supplierModalPaperProps}>
			<SupplierModalHeader
				title={selected ? "Edit contact person" : "Add contact person"}
				subtitle="Department, name, and communication details"
			/>
			<Box sx={{ ...modalContentSx, pt: 2.5, pb: 2 }}>
				<ContactPersonDetails person={updatedDetails} setPerson={setUpdatedDetails} />
			</Box>
			<SupplierModalActions onCancel={handleCloseModal} submitLabel="Save" />
		</Dialog>
	);
};

export default EditContactPersons;
